import { FC, useEffect } from 'react';
import Jobs from 'containers/jobs/Jobs';
import { selectCurrentTeam, selectIsActionsBlocked } from 'containers/app/appSlice';
import { useAppDispatch, useAppSelector } from 'hooks';
import MerchantOrTeamBlockedInfo from 'components/merchant-or-team-blocked/MerchantOrTeamBlockedInfo';
import { resetJobsActiveView, resetJobsCurrentViewFilters } from 'containers/jobs/jobsSlice';
import { useGetJobsInitQuery } from 'containers/jobs/api';
import { Loader } from 'components';

const JobsPage: FC = () => {
  const isActionsBlocked = useAppSelector(selectIsActionsBlocked);
  const currentTeam = useAppSelector(selectCurrentTeam);

  const dispatch = useAppDispatch();
  useEffect(() => {
    return () => {
      dispatch(resetJobsCurrentViewFilters());
      dispatch(resetJobsActiveView());
    };
  }, []);

  const { isFetching: isJobsInitFetching } = useGetJobsInitQuery(
    { teamId: currentTeam?.id },
    { skip: !currentTeam?.id }
  );

  if (isActionsBlocked) {
    return <MerchantOrTeamBlockedInfo title="Jobs" />;
  }

  if (isJobsInitFetching) {
    return <Loader />;
  }

  return <Jobs />;
};

export default JobsPage;
